import { defineMessages } from 'react-intl';

export const i18n: {
	hasAttachment: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	hasAttachment: {
		id: 'search-page.filters.names.has-attachment',
		defaultMessage: 'Has attachment',
		description: 'Label for filtering for items that have an attachment',
	},
});
